export function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

export function monthRangeIso(d: Date): { from: string; to: string } {
  const y = d.getFullYear();
  const m = d.getMonth();
  const last = new Date(y, m + 1, 0);
  return {
    from: `${y}-${pad2(m + 1)}-01`,
    to: `${y}-${pad2(m + 1)}-${pad2(last.getDate())}`,
  };
}

export function calendarEventsQueryKey(from: string, to: string, extraUserIdsKey: string) {
  return ['calendarEvents', from, to, extraUserIdsKey] as const;
}

export function hasProfilePermission(
  profile: { is_system_admin?: boolean; permissions?: Record<string, { slug: string }[]> } | null | undefined,
  slug: string
): boolean {
  if (profile?.is_system_admin) {
    return true;
  }
  if (!profile?.permissions) {
    return false;
  }
  for (const categoryPermissions of Object.values(profile.permissions)) {
    if (Array.isArray(categoryPermissions) && categoryPermissions.some((p) => p.slug === slug)) {
      return true;
    }
  }
  return false;
}
